import AsyncStorage from '@react-native-async-storage/async-storage';
import constantsStorage from 'constants/Storage';
import useStoredProducts from 'types/hooks/useStoredProducts';
import Product from 'types/models/Product';

export default (): useStoredProducts => {
  const storeProducts = async (products: Product[]): Promise<void> => {
    try {
      await AsyncStorage.setItem(constantsStorage.storedProducts, JSON.stringify(products));
    } catch (error) {
      console.log(error);
    }
  };

  const getStoredProducts = async (): Promise<Product[] | null> => {
    try {
      const productsInStorage = await AsyncStorage.getItem(constantsStorage.storedProducts);
      if (productsInStorage) {
      }
      const parsedProducts: Product[] = productsInStorage !== null && JSON.parse(productsInStorage);
      return parsedProducts;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  return { storeProducts, getStoredProducts };
};
